<template>
  <el-container style="height:100%;">
    <el-header>
      <span class="back-btn" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
    </el-header>
    <el-main>
      <div class="read-paper-body">
        <div class="stay-read-list">
          <p>活动列表</p>
          <ul class="answer-list-box">
            <li class="answer-list-options " v-for="(item,index) in itemList" :key="index">
              <span class="item-btn" :class="returnEventClass(item.is_read,index)" @click="changeItem(item.competition_id,item.id,index)">{{index+1}}</span>
            </li>
            <div style="clear: both;"></div>
          </ul>
        </div>
        <div class="paper-content-left">
          <div class="paper-header">
            <div class="student-info">
              <span class="info-item">{{paper_title}}</span>|
              <span class="info-item">参赛者:{{student_name}}</span>|
              <span class="info-item">满分：{{total_score}}</span>|
              <span class="info-item">分值占比：{{percent}}</span>|
              <span class="info-item">得分：{{student_score}}</span>
              <el-select v-model="classifyValue" placeholder="请选择" class="fr">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="score-info">
              <div class="info-left">
                <div class="info-left-item">客观成绩</div>
                <div class="info-left-item">主观成绩</div>
              </div>
              <div class="info-content">
                <table class="objective-table" border="1">
                  <thead>
                    <tr>
                      <td v-for="(it,i) in objective_score" :key="i">
                        <span>{{it.typeName}}</span>
                        <span>({{it.single_score}}分)</span>
                      </td>
                      <td>
                        <span>客观总分</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="(it,i) in objective_score" :key="i">{{it.get_score}}</td>
                      <td>{{objScore}}</td>
                    </tr>
                  </tbody>
                </table>
                <table class="subjective-table" border="1">
                  <thead>
                    <tr>
                      <td v-for="(it,i) in subjective_score" :key="i">
                        <span>{{it.typeName}}</span>
                        <span>({{it.single_score}}分)</span>
                      </td>
                      <td>
                        <span>主观总分</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="(it,i) in subjective_score" :key="i">{{it.get_score}}</td>
                      <td>{{subScore}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="info-right">
                <div class="info-right-up">
                  成绩
                </div>
                <div class="info-right-down">
                  {{objScore+subScore}}
                </div>
              </div>
            </div>
          </div>
          <div class="paper-content-body">
            <template v-for="(item,index) in questionList">
              <div class="question-type" :key="index">
                {{index+1 | NumberToChinese}}、{{item.paper_type | returnQuestionType}}（共{{item.count_type}}题、总{{item.single_score}}分）
                <span style="color:red;" v-if="subjectiveArr.includes(item.paper_type)">*此题型为主观题需要教师打分</span>
              </div>
              <template v-for="(it,idx) in item.paper_info">
                <ScResult v-if="it.paper_type===1" :itemContent="it" :index="idx" :name="student_name" :key="idx"></ScResult>
                <McResult v-if="it.paper_type===2" :itemContent="it" :index="idx" :name="student_name" :key="idx"></McResult>
                <JugeResult v-if="it.paper_type===3" :itemContent="it" :index="idx" :name="student_name" :key="idx"></JugeResult>
                <FillResult v-if="it.paper_type===4" :itemContent="it" :index="idx" :name="student_name" :key="idx"></FillResult>
                <ExplainResult v-if="it.paper_type===7" :itemContent="it" :index="idx" :name="student_name" type="contest" status="1" :key="idx"></ExplainResult>
                <ShortResult v-if="it.paper_type===8" :itemContent="it" :index="idx" :name="student_name" type="contest" status="1" :key="idx"></ShortResult>
                <TrainResult v-if="it.paper_type===9" :itemContent="it" :index="idx" :name="student_name" type="contest" status="1" :key="idx"></TrainResult>
                <MsResult v-if="it.paper_type===10" :itemContent="it" :index="idx" :name="student_name" :key="idx"></MsResult>
              </template>
            </template>
          </div>

        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import { correctPaperData, correctPaperSubmitData, getStudentEventData, returnQuestionType, returnType, NumberToChinese } from "@/api/show"
import ScResult from "@/components/result/SingleChoiceResult";
import McResult from "@/components/result/MultipleChoiceResult";
import MsResult from "@/components/result/MultipleSortResult";
import FillResult from "@/components/result/FillResult";
import JugeResult from "@/components/result/JugeMentResult";
import ShortResult from "@/components/result/ShortResult";
import ExplainResult from "@/components/result/ExplainResult";
import TrainResult from "@/components/result/TrainResult";
export default {
  components: {
    ScResult,
    McResult,
    MsResult,
    FillResult,
    JugeResult,
    ShortResult,
    ExplainResult,
    TrainResult,
  },
  data() {
    return {
      competitionId: '',//发布到班级的id
      studentId: '',//学生id
      paperId: '',//试卷id
      paper_title: '',//试卷名称
      student_name: '',//学生名字
      total_score: '',//试卷满分
      student_score: '',//学生成绩
      percent: '',//分值占比
      objective_score: [],//客观成绩
      subjective_score: [],//主观成绩
      classifyValue: 2,//默认显示主观题型
      tableData: [],//表头数据
      questionList: [],//题目列表
      subjectiveList: [],//主观题型列表
      allList: [],//所有题型列表
      remarkList: [],//教师评分列表
      itemList: [],//该学生所有活动列表
      currentIndex: '',//活动列表默认高亮位置
      teacherId: '',//批卷老师id
      is_read: '',//是否已经批阅
      options: [
        { value: 1, label: '显示全部题型' },
        { value: 2, label: '只显示主观题' },
      ],
      subjectiveArr: [7, 8, 9],//主观题型
      times: 0,//第几次参与
      classroom_id: 0,//专题id
    }
  },
  watch: {
    classifyValue: function () {
      let list = this.questionList
      if (this.classifyValue === 2) {
        let arr = []
        for (let i = 0; i < list.length; i++) {
          if (list[i].paper_type === 7 || list[i].paper_type === 8 || list[i].paper_type === 9) {
            arr.push(list[i])
          }
        }
        this.questionList = arr
      } else {
        this.questionList = this.allList
      }
    }
  },
  computed: {
    objScore: function () {
      let score = 0
      for (let i = 0; i < this.objective_score.length; i++) {
        score += this.objective_score[i].get_score
      }
      return score
    },
    subScore: function () {
      let score = 0
      for (let i = 0; i < this.subjective_score.length; i++) {
        score += this.subjective_score[i].get_score
      }
      return score
    },
  },
  created() {
    if (Object.keys(this.$route.params).length > 0) {
      this.competitionId = this.$route.params.competitionId
      this.studentId = this.$route.params.studentId
      this.times = this.$route.params.times
      this.replay_type = this.$route.params.replay_type
      this.classroom_id = this.$route.params.classroom_id
      let info = {
        competitionId: this.competitionId,
        studentId: this.studentId,
        times: this.times,
        replay_type: this.replay_type,
        classroom_id: this.classroom_id,
      }
      sessionStorage.setItem('resultInfo', JSON.stringify(info))
    } else {
      let info = sessionStorage.getItem('resultInfo')
      if (!info) return
      info = JSON.parse(info)
      this.competitionId = info.competitionId
      this.studentId = info.studentId
      this.times = info.times
      this.replay_type = info.replay_type
      this.classroom_id = info.classroom_id
    }
    this.getList()
  },
  mounted() {
    window.onbeforeunload = e => {
      if (this.$route.fullPath === "/show/read") {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      }
    };
    // 
    this.$root.$on('returnRemark', (subjectObj) => {
      if (Object.keys(subjectObj).length > 0) {
        let index = this.remarkList.findIndex((val) => {
          return val.title_id === subjectObj.title_id && val.title_type === subjectObj.title_type
        })
        if (index === -1) {
          this.remarkList.push(subjectObj)
        } else {
          this.remarkList.splice(index, 1, subjectObj)
        }
      }
    })
  },
  methods: {
    initData: function () {
      let params = {
        student_id: this.studentId,
        competition_id: this.competitionId,
        paper_id: this.paperId,
        times: this.times,
        replay_type: this.replay_type,
        classroom_id: this.classroom_id,
      }
      correctPaperData(params).then(response => {
        this.paper_title = response.data.paper_title
        this.student_name = response.data.student_name
        this.percent = response.data.percent
        this.total_score = response.data.total_score
        this.student_score = response.data.student_score
        this.allList = response.data.info
        let list = response.data.info
        if (this.classifyValue == 2) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].paper_type === 7 || list[i].paper_type === 8 || list[i].paper_type === 9) {
              this.questionList.push(list[i])
            }
          }
          //如果没有主观题,就显示全部题型
          if (!this.questionList.length) {
            this.classifyValue = 1
          }
        }
        this.getScore(response.data.info)
      })
    },
    getList: function () {
      let params = {
        student_id: this.studentId,
        competition_id: this.competitionId,
        times: this.times,
        replay_type: this.replay_type,
        classroom_id: this.classroom_id,
      }
      getStudentEventData(params).then(response => {
        this.itemList = response.data
        this.currentIndex = 0
        for (let i = 0; i < this.itemList.length; i++) {
          if (!this.itemList[i].is_read) {
            this.currentIndex = i
            break
          }
        }
        if (this.itemList.length) {
          this.paperId = this.itemList[this.currentIndex].paper_id
          this.initData()
        } else {
          this.$message.error('该考生没有答题')
        }
      })
    },
    //获取客观题分数和主观题分数
    getScore: function (data) {
      let objArr = [1, 2, 3, 4, 5, 6, 10]
      let subArr = [7, 8, 9]
      for (let i = 0; i < data.length; i++) {
        let arr = {}
        if (objArr.includes(data[i].paper_type)) {
          arr.get_score = data[i].get_score
          arr.single_score = data[i].single_score
          arr.count_type = data[i].count_type
          arr.paper_type = data[i].paper_type
          arr.typeName = returnQuestionType(data[i].paper_type)
          this.objective_score.push(arr)
        } else if (subArr.includes(data[i].paper_type)) {
          arr.get_score = data[i].get_score
          arr.single_score = data[i].single_score
          arr.count_type = data[i].count_type
          arr.paper_type = data[i].paper_type
          arr.typeName = returnQuestionType(data[i].paper_type)
          this.subjective_score.push(arr)
        }

      }
    },

    //批阅下一份试卷,id为学生该试卷的id
    nextPaper: function () {
      this.paperId = this.itemList[this.currentIndex].paper_id
      this.resetData()//重置数据
      this.initData()
    },
    //重置数据
    resetData: function () {
      this.total_score = '',//试卷满分
        this.student_score = '',//学生成绩
        this.objective_score = [],//客观成绩
        this.subjective_score = [],//主观成绩
        this.classifyValue = 2,//默认显示主观题型
        this.tableData = [],//表头数据
        this.questionList = [],//题目列表
        this.subjectiveList = [],//主观题型列表
        this.allList = [],//所有题型列表
        this.remarkList = []//教师评分列表
    },
    //切换活动列表,competitionId比赛id，itemId活动(试卷)id，当前活动(试卷)下标
    changeItem: function (competitionId, itemId, index) {
      if (this.currentIndex === index) {
        return
      }
      this.currentIndex = index
      this.nextPaper()
    },
    //返回批卷列表
    back: function () {
      if (window.history.length <= 1) {
        this.$router.push({ name: 'mark-list' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
    returnEventClass: function (isRead, index) {
      let cls = ''
      if (isRead) {
        cls += ' complete-btn'
      }
      if (this.currentIndex === index) {
        cls += ' current-btn'
      }
      return cls
    }
  },
  filters: {
    NumberToChinese: function (val) {
      return NumberToChinese(val)
    },
    returnQuestionType: function (val) {
      return returnQuestionType(val)
    },

  }
}

</script>

<style scoped="">
@import url("../../assets/css/show.css");
</style>
